import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Checkbox,
  Input,
  Label,
} from '@roger/ui-components';
import { WOUND_BED_TISSUE_TYPES } from '../../../constants/wounds';
import type { WoundBedState } from '../assessmentFormTypes';

interface WoundBedSectionProps {
  state: WoundBedState;
  onChange: (update: Partial<WoundBedState>) => void;
}

const WoundBedSection: React.FC<WoundBedSectionProps> = ({
  state,
  onChange,
}) => (
  <AccordionItem value='wound_bed' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Wound Bed
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-2'>
        <Checkbox
          id='wb-na'
          checked={state.notAssessed}
          onCheckedChange={v =>
            onChange({ notAssessed: !!v, ...(!v && { notAssessedReason: '' }) })
          }
        />
        <label htmlFor='wb-na' className='text-sm cursor-pointer'>
          Not Assessed
        </label>
      </div>
      {state.notAssessed && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {!state.notAssessed && (
        <div className='space-y-3'>
          <div className='grid grid-cols-2 gap-3'>
            {WOUND_BED_TISSUE_TYPES.map(({ key, label }) => (
              <div key={key} className='space-y-1'>
                <Label className='text-xs'>{label} (%)</Label>
                <Input
                  type='number'
                  step='1'
                  min='0'
                  max='100'
                  value={state.pcts[key]}
                  onChange={e =>
                    onChange({ pcts: { ...state.pcts, [key]: e.target.value } })
                  }
                  inputSize='sm'
                />
              </div>
            ))}
          </div>
          <div className='space-y-1.5'>
            <div className='flex items-center gap-2'>
              <Checkbox
                id='wb-other'
                checked={state.other}
                onCheckedChange={v =>
                  onChange({ other: !!v, ...(!v && { otherText: '' }) })
                }
              />
              <label htmlFor='wb-other' className='text-xs cursor-pointer'>
                Other
              </label>
            </div>
            {state.other && (
              <Input
                placeholder='Describe other tissue...'
                value={state.otherText}
                onChange={e => onChange({ otherText: e.target.value })}
                inputSize='sm'
              />
            )}
          </div>
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default WoundBedSection;
